"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);


var _model = require('shared/services/search/model');


const PAGE_SIZE = 10
const DEBOUNCE_MS = 300












const statusFor = (err) => {
  const extra = _optionalChain([(err ), 'optionalAccess', _ => _.extra])
  return _optionalChain([extra, 'optionalAccess', _2 => _2.Status]) === 'service_unavailable' ? 'unavailable' : 'error'
}

const itemsFor = (response, group) => {
  switch (group) {
    case 'chats': return _model.toChatItems.call(void 0, response.Conversations.Results)
    case 'messages': return _model.toMessageItems.call(void 0, response.Messages.Results, 'messages')
    case 'files': return _model.toMessageItems.call(void 0, response.Files.Results, 'files')
  }
}

const pageFor = (response, group) => {
  switch (group) {
    case 'chats': return response.Conversations
    case 'messages': return response.Messages
    case 'files': return response.Files
  }
}



















/**
 * Runs the search window's query against `Search` over everything you can
 * see (no scope, as today) and the chosen date range: the first page of every group after a short pause in typing,
 * then more of one group on request. Responses to an older query are
 * dropped.
 */
const useSearchResults = ({ query, daysLimit, useTestAlias, initial, groups, pageSize = PAGE_SIZE }) => {
  const [results, setResults] = _react.useState(_nullishCoalesce(_optionalChain([initial, 'optionalAccess', _3 => _3.results]), () => ( _model.EMPTY_RESULTS)))
  const [latestQuery, setLatestQuery] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([initial, 'optionalAccess', _4 => _4.query]), () => ( '')))
  const [status, setStatus] = _react.useState(_optionalChain([initial, 'optionalAccess', _5 => _5.query]) ? 'done' : 'idle')
  const [retries, setRetries] = _react.useState.call(void 0, 0)
  const epoch = _react.useRef.call(void 0, 0)
  const loadingMore = _react.useRef({})
  const resultsRef = _react.useRef.call(void 0, results)
  resultsRef.current = results
  const restored = _react.useRef.call(void 0, _nullishCoalesce(initial, () => ( null)))
  const groupsKey = (_nullishCoalesce(groups, () => ( _model.GROUPS.map(({ key }) => key)))).join(',')

  _react.useEffect.call(void 0, () => {
    const restore = restored.current
    restored.current = null
    if (restore && restore.query === query && restore.daysLimit === daysLimit) return

    const current = ++epoch.current
    loadingMore.current = {}
    if (!query) {
      setResults(_model.EMPTY_RESULTS)
      setLatestQuery('')
      setStatus('idle')
      return
    }
    setStatus('loading')
    const timer = setTimeout(() => {
      const asked = _model.GROUPS.filter(({ key }) => groupsKey.split(',').includes(key))
      const searchTypes = asked.map(({ searchType }) => ({ SearchType: searchType, Take: pageSize, Skip: 0 }))
      _actions2.default.search(query, searchTypes, daysLimit, useTestAlias)
        .then(response => {
          if (current !== epoch.current) return
          const next = { ..._model.EMPTY_RESULTS }
          asked.forEach(({ key }) => {
            const page = pageFor(response, key)
            next[key] = { items: itemsFor(response, key), totalHits: page.TotalHits, page: 0, hasMore: page.HasMore }
          })
          setResults(next)
          setLatestQuery(query)
          setStatus('done')
        })
        .catch((err) => {
          if (current !== epoch.current) return
          setResults(_model.EMPTY_RESULTS)
          setLatestQuery(query)
          setStatus(statusFor(err))
        })
    }, DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [query, daysLimit, useTestAlias, retries, groupsKey, pageSize])

  const loadMore = _react.useCallback.call(void 0, (group) => {
    const page = resultsRef.current[group]
    if (!page.hasMore || loadingMore.current[group] || !latestQuery) return
    loadingMore.current[group] = true
    const current = epoch.current
    const searchType = _model.GROUPS.find(g => g.key === group).searchType
    _actions2.default.search(
      latestQuery,
      [{ SearchType: searchType, Take: pageSize, Skip: (page.page + 1) * pageSize }],
      daysLimit,
      useTestAlias,
    )
      .then(response => {
        if (current !== epoch.current) return
        const more = pageFor(response, group)
        setResults(prev => {
          const seen = new Set(prev[group].items.map(item => item.id))
          return {
            ...prev,
            [group]: {
              items: [...prev[group].items, ...itemsFor(response, group).filter(item => !seen.has(item.id))],
              totalHits: more.TotalHits,
              page: prev[group].page + 1,
              hasMore: more.HasMore,
            },
          }
        })
      })
      .catch(() => {
        // The rows already shown stay; scrolling again retries.
      })
      .finally(() => {
        if (current === epoch.current) loadingMore.current[group] = false
      })
  }, [latestQuery, daysLimit, useTestAlias, pageSize])

  const retry = _react.useCallback.call(void 0, () => setRetries(n => n + 1), [])

  return { results, latestQuery, status, loadMore, retry }
}

exports. default = useSearchResults
